import React from 'react';
import { Label } from 'semantic-ui-react';
import 'semantic-ui-less/definitions/elements/label.less';

export default Label;
